import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface SkillListItem {
  id: number;
  name: string;
  external_ref: string;
  candidate_count: number;
}

export interface PaginatedSkillsResponse {
  items: SkillListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function listSkills(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; sort_by?: string; sort_order?: string }
): Promise<PaginatedSkillsResponse> {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 25));
  if (params?.sort_by) q.set("sort_by", params.sort_by);
  if (params?.sort_order) q.set("sort_order", params.sort_order);
  const url = `${API_URL}/skills?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des competences");
  return res.json();
}
